import React, {useState, useEffect, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import {getApiAlertRulesCount, getApiAlertRules, getApiAlertCodes, delApiAlertRulesId} from '../../common/fetch_api/alert'
import {BsTrash, BsPencilSquare, BsFillExclamationSquareFill, BsChevronExpand} from 'react-icons/bs'
import {PageNation} from '../../common/component_common.js';
import {AddAlertModal, EditAlertModal} from './modals';
import {DecideWindow} from '../../common/modal_common.js';

const PAGE_PER = 17;

export const View = () => {
    
    const [update, setUpdate] = useState(false);

    const [edgeSelCount, setEdgeSelCount] = useState(0);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);

    const [ruleList, setRuleList] = useState(null);

    const sortInfo = useRef({title:'enabled', order:'asc'});

    const [modalAddAlert, setModalAddAlert] = useState(false);
    const closeModalCreateAlert = () => setModalAddAlert(false);
    const showModalCreateAlert = () => setModalAddAlert(true);

    const [ruleInfo, setRuleInfo] = useState(null);
    const [modalEditAlert, setModalEditAlert] = useState(false);
    const closeModalEditAlert = () => setModalEditAlert(false);
    const showModalEditAlert = (rules) =>
    {
        setRuleInfo(rules);
        setModalEditAlert(true);
    }

    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (rules) => {
        setRuleInfo(rules);
        setModalDecide(true);
    };
    
    const SetDecideBody = () => {
        return (
            <div className='text-center'>
                <p>Are you sure you want to delete this Alert?</p>
            </div>
    )};

    const onClickRemoveAlert = (is) => {
        if( is === true)
        {
            Promise.resolve( delApiAlertRulesId(ruleInfo.id) )
            .then( done => {
                runUpdate();
            });
        }
    }

    const TdSeverityName = ({severity, name}) => {
        let icon = <></>;
        if(severity === 'info')
        {
            icon = <BsFillExclamationSquareFill className="text-good me-1" />;
        }
        else if(severity === 'warning')
        {
            icon = <BsFillExclamationSquareFill className="text-warning me-1" />;
        }
        else if(severity === 'critical')
        {
            icon = <BsFillExclamationSquareFill className="text-critical me-1" />;
        }

        return (
            <td>
                <span>{icon}</span><span>{name}</span>
            </td>
        )
    }

    const TdCondition = ({condition}) => {
        let contents = '';

        if( condition.type==='bool' )
        {
            contents = condition.right===1?"TRUE":"FALSE";
        }
        else if( condition.type==='none' )
        {
            contents = 'none';
        }
        else
        {
            contents = `Value ${condition.operator} ${condition.right}`;
        }

        return (
            <td>{contents}</td>
        )
    }

    const TdEdgeInfo = ({name = '', type = ''}) => {
        let typeStr = '';
        let nameStr = name;

        if( name.length < 1 && type.length < 1 )
        {
            typeStr = 'A';
            nameStr = 'All Edges';
        }
        else
        {
            if(type === 'm-agent')
            {
                typeStr = 'M';
            }
            else if(type === 's-agent')
            {
                typeStr = 'S';
            }
            else if(type === 'r-agent')
            {
                typeStr = 'R';
            }
            else if(type === 'rm')
            {
                typeStr = 'T';
            }
        }

        return (
            <td>
                <div className="edge-box edge-default me-2">{typeStr}</div><span>{nameStr}</span>
            </td>
        );
    }

    const getRules = () => {
        curPageRef.current.value = curPageState;

        Promise.resolve( getApiAlertRulesCount() )
        .then( data =>
        {
            if( data.count )
            {
                setEdgeSelCount(data.count);

                Promise.all( [getApiAlertRules(PAGE_PER, curPageState, sortInfo.current.title, sortInfo.current.order), getApiAlertCodes()] )
                .then( data => {

                    const ruleArr = data[0];
                    const codeArr = data[1];

                    const requiredCodes = getRequiredCodes(codeArr);
                    
                    setRuleList( ruleArr.map( (rules, index) =>
                        <tr className={`${rules.rule.enabled===true?'':'tr-disable'}`} key={index}>
                            <td>{`${rules.rule.enabled===true?'Enable':'Disable'}`}</td>
                            <TdSeverityName severity={rules.rule.severity} name={rules.rule.title}/>
                            <TdCondition condition={rules.rule.condition}/>
                            <TdEdgeInfo name={rules.rule.edgeName} type={rules.rule.edgeType}/>
                            <td>{`${rules.rule.duration}s`}</td>
                            <td> <Button variant="secondary" className="btn btn-icon" onClick={() => {showModalEditAlert(rules)}}><BsPencilSquare/></Button> </td>
                            {requiredCodes.indexOf(rules.rule.code) === -1
                                ?<td> <Button variant="danger" className="btn btn-icon" onClick={() => {showModalDecide(rules)}}><BsTrash/></Button></td>
                                :<td> <span className='text-danger text-opacity-75'>required</span> </td>
                            }
                        </tr>
                    ));

                    // let ruleRequire = [...ruleArr].filter( (item) => {return requiredCodes.indexOf(item.rule.code) !== -1});
                    // let ruleNormal = [...ruleArr].filter( (item) => {return requiredCodes.indexOf(item.rule.code) === -1});
                    
                    // setRuleList([
                    //     ruleRequire.map( (rules, index) =>
                    //         <tr key={index} className={`${rules.rule.enabled===true?'':'opacity-50'}`}>
                    //             <td>{`${rules.rule.enabled===true?'Enable':'Disable'}`}</td>
                    //             <TdSeverityName severity={rules.rule.severity} name={rules.rule.title}/>
                    //             <TdCondition condition={rules.rule.condition}/>
                    //             <TdEdgeInfo name={rules.rule.edgeName} type={rules.rule.edgeType}/>
                    //             <td>{`${rules.rule.duration}s`}</td>
                    //             <td> <Button variant="secondary" className="btn btn-icon" onClick={() => {showModalEditAlert(rules)}}><BsPencilSquare></BsPencilSquare></Button> </td>
                    //             <td> <span className='text-danger text-opacity-75'>required</span> </td>
                    //         </tr>
                    //     )
                    //     ,
                    //     ruleNormal.map( (rules, index) =>
                    //         <tr key={index} className={`${rules.rule.enabled===true?'':'opacity-50'}`}>
                    //             <td>{`${rules.rule.enabled===true?'Enable':'Disable'}`}</td>
                    //             <TdSeverityName severity={rules.rule.severity} name={rules.rule.title}/>
                    //             <TdCondition condition={rules.rule.condition}/>
                    //             <TdEdgeInfo name={rules.rule.edgeName} type={rules.rule.edgeType}/>
                    //             <td>{`${rules.rule.duration}s`}</td>
                    //             <td> <Button variant="secondary" className="btn btn-icon" onClick={() => {showModalEditAlert(rules)}}><BsPencilSquare></BsPencilSquare></Button> </td>
                    //             <td> <Button variant="danger" className="btn btn-icon" onClick={() => {showModalDecide(rules)}}><BsTrash></BsTrash></Button> </td>
                    //         </tr>
                    //     )
                    // ]);
                });
            }
            else
            {
                setRuleList(null);
            }
        })
    }

    function getRequiredCodes(codes)
    {
        const alertCode = codes.alertCode;
        let requiredCodes = [];
        for( const code of Object.keys(alertCode))
        {
            if( alertCode[code].required === true )
            {
                requiredCodes.push(alertCode[code].code);
            }
        }

        return requiredCodes;
    }
    
    function toggleSort(title)
    {
        let curTitle = sortInfo.current.title;
        let curOrder = sortInfo.current.order;

        if( curTitle === title )
        {
            if( curOrder === 'asc' )
            {
                curOrder = 'desc';
            }
            else
            {
                curOrder = 'asc';
            }
        }
        else
        {
            curTitle = title;
            curOrder = 'asc';
        }

        sortInfo.current = {title: curTitle, order: curOrder};

        runUpdate();
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() => {
        getRules();
    }, [update, curPageState]);

    return (
        <div className="tab-pane show active">
            <div className="col-xxl-12 mt-2">
                <div className="d-flex justify-content-end rules-btn me-2">
                    <button type="button" className="btn btn-primary btn-sm" onClick={showModalCreateAlert}>Add Alert</button>
                </div>
                <div className="section rules-area mt-2">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th className="sorting" sort-type='name' onClick={() => {toggleSort('enabled');}}>Enable<BsChevronExpand /></th>
                                <th className="sorting" sort-type='name' onClick={() => {toggleSort('title');}}>Name<BsChevronExpand /></th>
                                <th>Condition</th>
                                <th>Edge</th>
                                <th>Duration</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {ruleList}
                        </tbody>
                    </table>
                </div>
                <PageNation
                    curPageState={curPageState}
                    setCurPageState={setCurPageState}
                    selCount={edgeSelCount}
                    pagePer={PAGE_PER}
                    ref={curPageRef}
                ></PageNation>
                {modalAddAlert&&<AddAlertModal show={modalAddAlert} handleClose={closeModalCreateAlert} update={runUpdate}></AddAlertModal>}
                {modalEditAlert&&<EditAlertModal ruleInfo={ruleInfo} show={modalEditAlert} handleClose={closeModalEditAlert} update={runUpdate}></EditAlertModal>}
                {modalDecide&&<DecideWindow result={onClickRemoveAlert} show={modalDecide} handleClose={closeModalDecide} body={<SetDecideBody/>} okButtonTxt={'Remove'}></DecideWindow>}
            </div>
        </div>
    )
}